export const CHANGE_LANG = "CHANGE_LANG";
export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";
export const SIGN_OUT = "SIGN_OUT";

export const FETCHING_PROFILE = "FETCHING_PROFILE";
export const FETCHING_PROFILE_SUCCESS = "FETCHING_PROFILE_SUCCESS";
export const FETCHING_PROFILE_ERROR = "FETCHING_PROFILE_ERROR";
export const FETCHING_GENERAL_INFO = "FETCHING_GENERAL_INFO";
export const FETCHING_LIST_BANK = "FETCHING_LIST_BANK";
